import React from 'react'
import { Contact } from '../../component/contact/Contact'

export default function ContactPage() {
  return (
    <>
      <Contact />
    </>
  )
}
